import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  padding: 24px 32px;
  -webkit-box-shadow: 0px -8px 20px 0px #0000000f;
  box-shadow: 0px -8px 20px 0px #0000000f;

  /* position: absolute;
  left: 0;
  right: 0;
  bottom: 0; */
`;
